<div class="full-width">

    <div class="h5">
        <p>Total fees of {{task.amountDue / 100 | currency}} are due now to complete your license application.</p>
        <p>Click "Proceed" below to add to your shopping cart and checkout</p>
    </div>

    <button mat-stroked-button (click)="addToCartAndCheckout()">Proceed</button>
</div>